<template lang='pug'>
  .software-changed
    top-arch
    v-row.text-center(row justify-center)
      v-col(cols='12')
        .display-2.pa-4.font-weight-thin.grey--text.text--darken-3 Software Creation Has Changed,<br/> Automated Software Test Tools Have Not
    v-row(justify='center')
      v-col(cols='12' md='10' lg='7')
        v-row(no-gutters).pt-4
          v-col(cols='5').text-center
            div.display-1.font-weight-light.grey--text.text--darken-3 Then
          v-col(cols='2').text-center
            v-divider(vertical)
          v-col(cols='5').text-center
            div.display-1.font-weight-light.grey--text.text--darken-3 Now
        v-divider
        v-row(no-gutters)
          v-col(cols='5').text-center
            div.mt-4.text-item.grey--text.text--darken-1 Waterfall
          v-col(cols='2').text-center
            v-divider(vertical)
          v-col(cols='5').text-center
            div.mt-4.text-item.grey--text.text--darken-1 Agile, Kanban, Continuous Delivery
        v-row(no-gutters)
          v-col(cols='5').text-center
            div.mt-3.text-item.grey--text.text--darken-1 Long Release Cycles
          v-col(cols='2').text-center
            v-divider(vertical)
          v-col(cols='5').text-center
            div.mt-3.text-item.grey--text.text--darken-1 Frequent Releases, Continuous Releases
        v-row(no-gutters)
          v-col(cols='5').text-center
            div.mt-3.text-item.grey--text.text--darken-1 Code Freeze and Test Before Release
          v-col(cols='2').text-center
            v-divider(vertical)
          v-col(cols='5').text-center
            div.mt-3.text-item.grey--text.text--darken-1 Continuous Development, Code is Never Frozen
        v-row(no-gutters)
          v-col(cols='5').text-center
            div.mt-3.text-item.grey--text.text--darken-1 Single Tenant / On-Premise Depoyments
          v-col(cols='2').text-center
            v-divider(vertical)
          v-col(cols='5').text-center
            div.mt-3.text-item.grey--text.text--darken-1 Multi-Tenant Cloud Applications ⇒ Defects Have Widespread Impact
        v-row(no-gutters)
          v-col(cols='5').text-center
            div.mt-3.text-item.grey--text.text--darken-1 Applications Static
          v-col(cols='2').text-center
            v-divider(vertical)
          v-col(cols='5').text-center
            div.mt-3.text-item.grey--text.text--darken-1 Applications “Live” and “Breathe”
    v-row.pt-4.text-center(justify='center')
      v-col(cols='12' md='10' lg='6')
        .headline.pa-4.grey--text.text--darken-2 Every step of the software development process is faster. Bionic Metric's automated test platform can help you keep pace with your software and app testing.
</template>

<script>
import TopArch from './TopArch';

export default {
  name: 'SoftwareChanged',
  components: {TopArch},
  data() {
    return {
      visible: false
    };
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .software-changed {
    background-color: #E0F2F1;
    padding-top: 0;
    margin-top: 0;
    padding-bottom: 40px;
    min-height: 80vmin;
  }

  .text-item {
    font-size: calc(14px + 0.5vmin);;
  }
</style>
